<template>
  <div class="disciplinaryMeasure">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <employee-sidebar v-if="currentUser.employee.designation.departmentId === 14">
      </employee-sidebar>
      <layout-sidebar v-else></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Training Program</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Training Program</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a @click="openDialog" class="btn add-btn"
                  ><i class="fa fa-plus"></i> Add Program</a
                >
                <a @click="openImport" class="btn add-btn mx-3"
                  ><i class="fa fa-plus"></i> Import Program</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="trainingPrograms"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" @click="setEditProgramme(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a
                          class="dropdown-item"
                          @click="setDeleteProgramme(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add training program Modal -->
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Training Program</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Skill Gap <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="skillGapId">
                    <option>Select Skill Gap</option>
                    <option
                      v-for="member in skillGaps"
                      :key="member.id"
                      :value="member.id"
                    >
                      {{ member.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Program <span class="text-danger">*</span></label>
                  <input
                    v-model="programme"
                    id="program"
                    name="program"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onSubmit"
                    data-dismiss="modal"
                    class="btn btn-primary submit-btn"
                    :disabled="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Training Provide Modal -->

        <!-- Edit Training Provider Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Training Provider</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Skill Gap <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="trainingProgram.skillGapId"
                  >
                    <option>Select Skill Gap</option>
                    <option
                      v-for="member in skillGaps"
                      :key="member.id"
                      :value="member.id"
                    >
                      {{ member.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Program <span class="text-danger">*</span></label>
                  <input
                    v-model="trainingProgram.programme"
                    id="program"
                    name="program"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onPutSubmit"
                    data-dismiss="modal"
                    class="btn btn-primary submit-btn"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit training needs Modal -->

        <!-- Delete training needs Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Training Program</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      class="btn btn-primary continue-btn"
                      @click="onDeleteSubmit"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      @click="closeDelete"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete disciplinaryCase Modal -->
        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogImport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Programme</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeImport"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Import Programme</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row) in first sheet only. <br />
                    Regards <strong>Skill Gap Number</strong> column you are
                    expected to get the value from its representing sheet.
                    <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplate"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importProgramme"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import EmployeeSidebar from "@/components/layouts/employeeSidebar.vue"
import { required, sameAs } from "vuelidate/lib/validators";
import { trainingService } from "@/services/trainingService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    EmployeeSidebar,
    Datepicker
  },

  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      headers: [
        { text: "Skill Gap", value: "skillGap.name" },
        { text: "Program", value: "programme" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      // form: "",
      skillGapId: "",
      programme: "",
      loading: false,
      error: "",
      skillGaps: [],
      submitted: false,
      trainingPrograms: [],
      trainingProgram: {},
      currentUser: authenticationService.currentUserValue,
      //employee: authenticationService.currentOfficeValue,
      company: authenticationService.currentOfficeValue,
      user: authenticationService.currentUserValue,
      file: null,
      fileName: ""
    };
  },

  validations: {
    skillGapId: { required },
    programme: { required }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },
  methods: {
    getSkillGaps() {
      trainingService.getSkillGap(this.company.id).then(
        model => {
          this.skillGaps = model;
        },
        error => {
          error = error;
        }
      );
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },
    openDialog() {
      this.dialog = true;
    },
    openImport() {
      this.dialogImport = true;
    },
    close() {
      this.clearList();
      this.dialog = false;
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeImport() {
      this.dialogImport = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    clearList() {
      this.employeeId = "";
      this.skillGapId = "";
      this.programme = "";
      this.submitted = false;
    },
    setEditProgramme(model) {
      this.trainingProgram = model;
      this.dialogEdit = true;
    },
    setDeleteProgramme(model) {
      this.trainingProgram = model;
      this.dialogDelete = true;
    },
    getProgrammes() {
      trainingService.getTrainingProgrammes(this.company.id).then(r => {
        this.trainingPrograms = r;
      });
    },
    onDeleteSubmit() {
      const id = this.trainingProgram.id;
      trainingService.removeProgramme(id).then(id => {
        trainingService.getTrainingProgrammes(this.company.id).then(r => {
          this.trainingPrograms = r;
          this.closeDelete();
        });
      });
    },
    importProgramme() {
      trainingService.importProgramme(this.company.id, this.file).then(id => {
        trainingService.getTrainingProgrammes(this.company.id).then(r => {
          this.providers = r;
          this.closeImport();
        });
      });
    },

    onSubmit() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      trainingService
        .addProgramme({
          programme: this.programme,
          skillGapId: this.skillGapId
        })
        .then(
          id => {
            this.message = "Training Programme created successfully";
            trainingService.getTrainingProgrammes(this.company.id).then(r => {
              this.trainingPrograms = r;
              this.close();
            });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },
    downloadTemplate() {
      trainingService.downloadProgrammeTemplate(this.company.id).then(
        response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        },
        error => {
          this.error = error;
        }
      );
    },
    onPutSubmit() {
      console.log(this.skillType);
      this.loading = true;
      trainingService.editProgramme(this.trainingProgram).then(
        id => {
          trainingService.getTrainingProgrammes(this.company.id).then(r => {
            this.trainingPrograms = r;
            this.closeEdit();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },

  mounted() {
    this.getSkillGaps();
    this.getProgrammes();
    // Datatable
    //this.getEmployees(this.employee.id);
    //this.getEmployeedisciplinaryMeasures(this.company.id);

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    $(document).on("change", "#customleave_select", function() {
      //$(this).find('option:selected')
      return false;
    });
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "trainingProgram"
};
</script>



// WEBPACK FOOTER //
// src/components/training/trainingProgram.vue